/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { AnalyticsPageService } from '@pages/AnalyticsPage/services';

const getSrv = () => {
  return vappContainer.get<AnalyticsPageService>(AnalyticsPageService.name);
};

export const getAnalytics = async (context: any, event: any) => {
  const currentState = 'GET_ANALYTICS';
  const method = 'getAnalytics';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const shelves = await srv.agent.getAnalytics();
      if (shelves) {
        return resolve({
          key: 'RENDER_ANALYTICS',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_ANALYTICS_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_ANALYTICS_ERROR',
        value: err?.message,
      });
    }
  });
};
